// src/app/features/offer/components/offer-submit-view.tsx

import React from "react";
import {Button} from "@/app/global-components/button"; // Ensure this path is correct
import {ImSpinner2} from "react-icons/im";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";

interface saveOrderSubmitViewProps {
  isLoading: boolean;
  onClick: () => void;
}

const SendOrderSubmitView: React.FC<saveOrderSubmitViewProps> = ({isLoading,onClick}) => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  return (
    <div>
      <Button
        className="flex items-center bg-secondary-brightYellow shadow text-textcolor-black w-full py-2 px-4 text-sm" style={{background:'#000',color:"#fff"}}
        onClick={onClick}
        disabled={isLoading}
      >
        {isLoading ? (
          <>
            <span className="ml-2 animate-spin">
              <ImSpinner2 />
            </span>
            
            {t("actions.confirmingOrder")}
          </>
        ) : (
          
          t("actions.confirmOrder")
          
        )}
      </Button>
    </div>
  );
};

export default SendOrderSubmitView;
